import React from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@mui/material/MenuItem';

const noop = () => {};
const OptionsDropdownItem = ({
  onClick = noop,
  disabled = false,
  children,
}) => {
  return (
    <MenuItem disabled={disabled} onClick={disabled ? noop : onClick}>
      {children}
    </MenuItem>
  );
};

OptionsDropdownItem.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.node,
};

export default OptionsDropdownItem;
